<template>
	<div :class="['part', type, $store.state.bouncingArrow && type === 'message' ? 'message--arrow' : null]">
		<div :class="['lottie', lottieLoaded ? 'lottie--loaded' : null]" ref="svg"><img :src="image" height="100%" /></div>
		<div class="part__copy">
			<slot name="title"/>
			<slot/>
		</div>
	</div>
</template>

<script>
import lottie from 'lottie-web';

export default {
	props: ['type'],
	data () {
		return {
			lottieLoaded: false,
		};
	},
	computed: {
		image () {
			return require(`../assets/images/ico-${this.type}.svg`);
		},
	},
	mounted () {
		const _this = this;

		const animation = lottie.loadAnimation({
			container: this.$refs.svg,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData: require(`@/assets/json/howto-${this.type}.json`),
		});
		animation.addEventListener('DOMLoaded', function (e) {
			_this.lottieLoaded = true;
		});
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';

	.part { display: flex; align-items: flex-start;
		h4 { margin: 0 0 1ex 0; font-size: 26/16rem; text-transform: uppercase;
			span { color: @yellow; }
		}
		&__copy { width: 80%; padding-left: 25px; margin-bottom: 40px; text-align: left;
			p { text-align-last: left; }
			&:last-of-type { margin-bottom: 0; }
		}
		.lottie { display: inline; .size(20%, 100%);
			img { width: 100%; }
			&--loaded { min-width: 110px; height: 110px; min-height: 110px;
				svg { height: 110px; }
				img { display: none; }
			}
		}
		.lottie--loaded + .part__copy { padding-left: 10px; }
		&.gift .lottie { width: 15%; margin-right: 5%;
			&--loaded {  margin-right: 0; }
		}
		&.message { position: relative;
			img { height: 65px; }
			@keyframes arrow {
				0% { transform: translateX(-5px); }
				100% { transform: translateX(20px); }
			}
			&:after { opacity: 0; animation: arrow 3s 3s ease-in-out infinite alternate; transition: opacity 0.5s ease; filter: drop-shadow(8px 8px 10px fade(#000, 11)); .top-right(-118px / 2, -223px); .size(223px,118px); display: block; content: ""; background: transparent url(../assets/images/ico-start-here.svg) 0 0 / contain no-repeat; }
			&--arrow {
				&:after { opacity: 1; }
			}
		}
		&.share .lottie--loaded { transform: translateY(-30px); }
	}

	@media @tablet {
		.part {
			.lottie { width: 110px; margin-right: 10px; }
			&__copy { width: auto; }
			&.message:after { display: none; }
			&.gift .lottie { width: 110px;
				&--loaded {  margin-right: 10px; }
			}
		}
	}

	@media @mobile {
		.part {
			h4 { font-size: 18/16rem; }
			&.message:after { display: none; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/TheInfoItem.vue